
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class SacredGeometryEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time } = pc;
         const r = (150 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, r * 2);
        const scale = config.parallaxScale || 1.0;
        const curTime = time * config.parallaxSpeed;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1.5 * scale;

        const drawSymbol = (x: number, y: number, radius: number) => {
            // Overlapping circles pattern (Seed of Life variant)
            ctx.beginPath();
            ctx.arc(x, y, radius, 0, Math.PI * 2);
            ctx.stroke();

            for (let i = 0; i < 6; i++) {
                const a = (i / 6) * Math.PI * 2 + curTime * 0.2;
                const sx = x + Math.cos(a) * radius;
                const sy = y + Math.sin(a) * radius;
                ctx.beginPath();
                ctx.arc(sx, sy, radius, 0, Math.PI * 2);
                ctx.stroke();
            }
        };

        const draw = () => {
            for (let x = x1; x <= x2; x += r * 2) {
                for (let y = y1; y <= y2; y += r * 2) {
                    drawSymbol(x, y, r * 0.5 * scale);
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
